import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { analyticsApi } from '@/api';
import { analyticsKeys } from '@/lib/queryKeys';
import { GC_TIMES, STALE_TIMES } from '@/lib/constants';
import type { EfficiencyParams } from '@/types/api';

export function useEfficiency(params: EfficiencyParams = {}) {
  return useQuery({
    queryKey: analyticsKeys.efficiency(params),
    queryFn: () => analyticsApi.efficiency(params),
    staleTime: STALE_TIMES.long,
    gcTime: GC_TIMES.long,
    placeholderData: keepPreviousData,
  });
}
